import { siteInfo } from "@/mocks/siteData";

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6 text-center">
        <div className="relative rounded-3xl overflow-hidden mb-12">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20overhead%20flat%20lay%20composition%20of%20carefully%20arranged%20fashion%20accessories%20including%20a%20leather%20watch%20folded%20scarf%20sunglasses%20and%20small%20leather%20goods%20on%20a%20warm%20cream%20marble%20surface%2C%20soft%20natural%20daylight%20from%20above%2C%20editorial%20luxury%20lifestyle%20photography%2C%20harmonious%20arrangement%2C%20sophisticated%20warm%20neutral%20aesthetic&width=1400&height=600&seq=cta-new-v2-2026&orientation=landscape"
            alt="Superbuy Spreadsheet product collection"
            className="w-full h-64 md:h-80 object-cover"
          />
          <div className="absolute inset-0 bg-black/15"></div>
        </div>

        <h2 className="text-3xl md:text-5xl font-heading font-bold leading-[1.3] mb-8">
          <span className="text-foreground-950">Ready to Access the </span>
          <span className="text-foreground-400 italic font-normal">Superbuy Spreadsheet</span>
          <span className="text-foreground-950">?</span>
        </h2>

        <p className="text-base md:text-lg text-foreground-600 max-w-xl mx-auto mb-10">
          Thousands of verified product links, organized by category, updated regularly. Start exploring the best deals today.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={siteInfo.mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-10 py-4 rounded-full bg-primary-500 text-background-50 text-base font-bold hover:bg-primary-600 transition-all hover:scale-[1.02] cursor-pointer whitespace-nowrap"
          >
            Explore Superbuy Spreadsheet
            <i className="ri-arrow-right-line ml-2 w-4 h-4 inline-flex items-center justify-center"></i>
          </a>
          <a
            href={siteInfo.mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-10 py-4 rounded-full bg-accent-500 text-background-50 text-base font-bold hover:bg-accent-600 transition-all hover:scale-[1.02] cursor-pointer whitespace-nowrap"
          >
            Buy It Now
            <i className="ri-shopping-cart-line ml-2 w-4 h-4 inline-flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}